import { blastForecastClientConfig, type BlastForecastClientInterface } from './blastForecastClient.types';
import CorporateBlastForecastClient from './corporateBlastForecastClient';
import OrgUnitBlastForecastClient from './orgUnitBlastForecastClient';
import type { ClientContext } from '~/services/contextClient';

export default class BlastForecastClientFactory {
    static createClient(context: ClientContext): BlastForecastClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateBlastForecastClient(context.teamId, blastForecastClientConfig);
        } else if (context.orgUnitId) {
            return new OrgUnitBlastForecastClient(context.teamId, context.orgUnitId, blastForecastClientConfig);
        } else if (context.groupId) {
            throw new Error('Group blast forecast client not yet implemented');
        }

        throw new Error('Invalid context');
    }
}
